import { Zap } from 'lucide-react';

interface SuggestedLessonsProps {
  suggestions: {
    suggested_lessons?: string[];
    go_deeper?: string[];
    build_foundation?: string[];
    coaching_note?: string;
  };
  onSuggestionClick?: (suggestion: string) => void;
}

const SuggestedLessons = ({ suggestions, onSuggestionClick }: SuggestedLessonsProps) => {
  const hasSuggestions = 
    (suggestions.suggested_lessons && suggestions.suggested_lessons.length > 0) ||
    (suggestions.go_deeper && suggestions.go_deeper.length > 0) ||
    (suggestions.build_foundation && suggestions.build_foundation.length > 0);

  if (!hasSuggestions) return null;

  const handleClick = (suggestion: string) => {
    if (onSuggestionClick) {
      onSuggestionClick(suggestion);
    }
  };

  return (
    <div className="space-y-6" style={{ fontFamily: 'Lexend Deca' }}>
      {/* Continue Learning */}
      {suggestions.suggested_lessons && suggestions.suggested_lessons.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-3">Continue Learning</h3>
          <div className="grid grid-cols-1 gap-0">
            {suggestions.suggested_lessons.map((lesson, i) => (
              <div key={i}>
                <button
                  onClick={() => handleClick(lesson)}
                  className="w-full text-left px-4 py-3 bg-transparent transition-all duration-150 text-sm flex items-center gap-2 rounded-xl"
                  style={{ color: '#666666' }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F4F3F1'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <Zap className="w-4 h-4 flex-shrink-0" style={{ color: '#666666' }} />
                  <span>{lesson}</span>
                </button>
                {i < suggestions.suggested_lessons.length - 1 && (
                  <div className="px-[10px]">
                    <div className="border-b border-gray-200" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Go Deeper */}
      {suggestions.go_deeper && suggestions.go_deeper.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-3">Go Deeper</h3>
          <div className="grid grid-cols-1 gap-0">
            {suggestions.go_deeper.map((topic, i) => (
              <div key={i}>
                <button
                  onClick={() => handleClick(topic)}
                  className="w-full text-left px-4 py-3 bg-transparent transition-all duration-150 text-sm flex items-center gap-2 rounded-xl"
                  style={{ color: '#666666' }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F4F3F1'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <Zap className="w-4 h-4 flex-shrink-0" style={{ color: '#666666' }} />
                  <span>{topic}</span>
                </button>
                {i < suggestions.go_deeper.length - 1 && (
                  <div className="px-[10px]">
                    <div className="border-b border-gray-200" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Build Foundation */}
      {suggestions.build_foundation && suggestions.build_foundation.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-3">Build Foundation</h3>
          <div className="grid grid-cols-1 gap-0">
            {suggestions.build_foundation.map((topic, i) => (
              <div key={i}>
                <button
                  onClick={() => handleClick(topic)}
                  className="w-full text-left px-4 py-3 bg-transparent transition-all duration-150 text-sm flex items-center gap-2 rounded-xl"
                  style={{ color: '#666666' }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F4F3F1'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <Zap className="w-4 h-4 flex-shrink-0" style={{ color: '#666666' }} />
                  <span>{topic}</span>
                </button>
                {i < suggestions.build_foundation.length - 1 && (
                  <div className="px-[10px]">
                    <div className="border-b border-gray-200" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SuggestedLessons;

